import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
//import "swiper/css/free-mode";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar } from "swiper/modules";
import type { ProductByIdPdp } from "@/Models/MPDP/ProductByIdPDP";
import { ImageCarousel, ModalViewImage } from "@/Components/Index";
import { changeImagenParams } from "@/Utils/Product.Image.View";

type Props = {
  mDatos: ProductByIdPdp[];
  openModal: boolean;
  onClickModal: (valu: boolean) => void;
  isLoading: boolean;
};

export const ProductImageView = ({
  mDatos,
  openModal,
  onClickModal,
  isLoading,
}: Props): JSX.Element => {
  /***** Cambio en la imagen del PDP y Modal *******/

  //cerramos el modal.
  const handleOnClickModal = () => {
    const valor = openModal ? false : true;
    onClickModal(valor);
  };
  /***** End PDP y Modal *******/
  const imageZoomGroups = mDatos[0]?.ImageZoomGroups[0]?.images;
  const imageDefault = mDatos[0]?.Default ? mDatos[0]?.Default : "";

  return (
    <figure>
      <div className="ps-wrapper">
        <div className="ps-product__gallery">
          <Swiper
            loop={false}
            modules={[Navigation, Pagination, Scrollbar]}
            navigation
            pagination={{ clickable: true }}
            scrollbar={{ draggable: true }}>
            {imageZoomGroups?.map((w, i) => (
              <SwiperSlide key={i}>
                <Link to={""} onClick={handleOnClickModal}>
                  <ImageCarousel
                    srcx={changeImagenParams(w?.link, 1500, 1500, 99)}
                    altx={w?.alt}
                    classNames={""}
                    srcDefault={imageDefault}
                  />
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        {openModal ? (
          <ModalViewImage
            mDatos={mDatos}
            closeModals={handleOnClickModal}
            isLoading={isLoading}
          />
        ) : (
          ""
        )}
      </div>
    </figure>
  );
};
